import { modalName } from '@va/constants';
import { closeModal } from '@va/dashboard/actions/ui';
import { isModalOpen } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { Button, GrayGradientDivider, ModalHeader } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UrlStructureItems } from './UrlStructureItems';

export const UrlStructureModal = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();

  const isOpen = useSelector((state) => isModalOpen(state, modalName.urlStructureModal));

  const onClose = useCallback(() => {
    dispatch(closeModal(modalName.urlStructureModal));
  }, [dispatch]);

  return (
    <ModalWrapper closeModal={onClose} isModalOpen={isOpen}>
      <div className='max-w-720px'>
        <ModalHeader title={translate('url.urlStructure')} onClose={onClose} />
        <div className='px-4 pt-4 pb-3 overflow-auto scrollbar scrollbar-thumb'>
          <UrlStructureItems />
        </div>
        <GrayGradientDivider className='mt-2' />
        <div className='p-4'>
          <Button onClick={onClose} className='w-full' color='tertiary' text={translate('button.close')} />
        </div>
      </div>
    </ModalWrapper>
  );
};
